export const channelKeys = {
  all: ['channels'] as const,
};
